import React, { useState, useEffect } from 'react';

const AboutSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const rotatingImages = [
    'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/ry9g7xa5_Gemini_Generated_Image_k5gzztk5gzztk5gz.png',
    'https://customer-assets.emergentagent.com/job_desert-pump-guard/artifacts/e0vjte0q_Gemini_Generated_Image_4grzti4grzti4grz.png'
  ];

  // Auto-rotate images every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % 2);
    }, 3000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              About <span className="text-amber-700">Camel Rubber Bush</span>
            </h2>
            <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-5xl mx-auto whitespace-nowrap">
              Premium quality rubber bushes designed for submersible pumps that face the toughest conditions
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image Side - Rotating Images */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={rotatingImages[currentImageIndex]}
                  alt="Camel Rubber Bush Product"
                  className="w-full h-[500px] object-cover transition-opacity duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-amber-500 rounded-full opacity-20 blur-3xl"></div>
              
              {/* Image indicators */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                {rotatingImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      currentImageIndex === index 
                        ? 'bg-amber-500 w-6' 
                        : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Text Side */}
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-800">
                Why Choose Camel?
              </h3>
              <p className="text-gray-700 leading-relaxed text-lg">
                Just as a camel stands resilient in the sandy desert, our Camel Rubber Bush is engineered 
                to endure the harshest conditions. When submersible pumps draw water, they inevitably pull 
                sand and debris along with it. This constant abrasion destroys ordinary rubber bushes quickly.
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                Our specially formulated rubber compound provides exceptional resistance to both extreme 
                heat and sand erosion, significantly extending pump life and reducing maintenance costs.
              </p>

              {/* Key Features */}
              <div className="grid grid-cols-3 gap-4 pt-6">
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-5 rounded-xl border border-amber-200 text-center">
                  <div className="text-lg font-bold text-amber-700 leading-snug">
                    Field<br/>Tested
                  </div>
                </div>
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-5 rounded-xl border border-amber-200 text-center">
                  <div className="text-lg font-bold text-amber-700 leading-snug">
                    Premium<br/>Quality
                  </div>
                </div>
                <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-5 rounded-xl border border-amber-200 text-center">
                  <div className="text-lg font-bold text-amber-700 leading-snug">
                    Multiple<br/>Sizes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
